import { useState } from 'react';
import classNames from 'classnames';

import { SectionTitle, CollapsibleItem } from '@/ui/index';

import ContentBlock from './ContentBlock';
import EmptyBlock from './EmptyBlock';

import styles from './ChooseTopic.module.scss';

const ChooseTopic = ({ pageData, dark = false }) => {
  const [topics, setTopics] = useState();
  const [topic, setTopic] = useState();

  const renderLinks = (list, key) => {
    return (
      <div
        className={`${styles.list} grid-extend`}
        key={key}
        itemScope
        itemType='https://schema.org/ItemList'
      >
        {list.map((item, key) => (
          <>
            <div
              className={`${styles.link} ${
                topic === item.id ? styles.active : ''
              }`}
              key={item?.id || key}
              onClick={() => {
                setTopic(item.id);
                setTopics(item);
              }}
            >
              {item.title}
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: item.content,
              }}
            ></div>
          </>
        ))}
      </div>
    );
  };

  const renderCategory = (item, key) => {
    return (
      <CollapsibleItem
        toggle={item?.title}
        content={renderLinks(item?.topics)}
        // defaultStatus={category === item.link}
        className={classNames([styles.item, { [styles.dark]: dark }])}
        key={key}
        itemScope
        itemType='https://schema.org/ItemList'
      />
    );
  };

  return (
    <div
      className={'wrapper section'}
      itemScope
      itemType='https://schema.org/ItemList'
    >
      <div className={styles.title}>
        <SectionTitle titleModify='title--large'>
          {'Choose the topic'}
        </SectionTitle>
      </div>
      <div className={`${styles.container} grid-extend`}>
        <div className={`${styles.categories} grid-extend`}>
          {pageData?.subsections?.map(renderCategory)}
        </div>
        <div
          className={classNames([styles.content, { [styles.empty]: !topic }])}
          itemScope
          itemType='https://schema.org/CreativeWork'
        >
          {topic ? <ContentBlock dark={dark} data={topics} /> : <EmptyBlock />}
        </div>
      </div>
    </div>
  );
};

export default ChooseTopic;
